(() => {
  if (window.CyberMonkeyMatrixLoaded) return;
  window.CyberMonkeyMatrixLoaded = true;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const characters = '01<>[]{}#/CMJ';

  function initMatrix(root) {
    const canvas = root.querySelector('[data-matrix-canvas]');
    if (!canvas || canvas.dataset.initialized === 'true') return;
    canvas.dataset.initialized = 'true';

    if (reducedMotion.matches) return;

    const context = canvas.getContext('2d', { alpha: true });
    if (!context) return;

    const intensity = Number(canvas.dataset.intensity || 50);
    const fontSize = Math.max(14, 22 - Math.round(intensity / 12));
    const frameInterval = Math.max(55, 105 - intensity / 2);
    let columns = 0;
    let drops = [];
    let animationFrame = 0;
    let lastFrame = 0;
    let active = true;

    function resize() {
      const bounds = root.getBoundingClientRect();
      const width = Math.max(320, Math.round(bounds.width));
      const height = Math.max(480, Math.round(bounds.height));
      const pixelRatio = Math.min(window.devicePixelRatio || 1, 1.5);

      canvas.width = Math.round(width * pixelRatio);
      canvas.height = Math.round(height * pixelRatio);
      canvas.style.width = width + 'px';
      canvas.style.height = height + 'px';
      context.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);

      columns = Math.ceil(width / fontSize);
      drops = Array.from({ length: columns }, (_, index) => drops[index] ?? -Math.random() * 50);
    }

    function draw(timestamp) {
      if (!active) return;

      animationFrame = window.requestAnimationFrame(draw);
      if (timestamp - lastFrame < frameInterval) return;
      lastFrame = timestamp;

      const width = canvas.clientWidth;
      const height = canvas.clientHeight;
      context.fillStyle = 'rgba(0, 0, 0, 0.1)';
      context.fillRect(0, 0, width, height);
      context.font = fontSize + 'px monospace';

      for (let index = 0; index < columns; index += 1) {
        const character = characters[Math.floor(Math.random() * characters.length)];
        const bright = Math.random() > 0.94;
        context.fillStyle = bright ? '#b8ff9f' : 'rgba(57, 255, 20, 0.62)';
        context.fillText(character, index * fontSize, drops[index] * fontSize);

        if (drops[index] * fontSize > height && Math.random() > 0.975) {
          drops[index] = -Math.random() * 15;
        }
        drops[index] += 1;
      }
    }

    resize();

    const visibilityObserver = new IntersectionObserver((entries) => {
      active = entries[0].isIntersecting;
      window.cancelAnimationFrame(animationFrame);
      if (active) animationFrame = window.requestAnimationFrame(draw);
    });
    visibilityObserver.observe(root);

    const resizeObserver = new ResizeObserver(resize);
    resizeObserver.observe(root);
  }

  function initAll(scope = document) {
    scope.querySelectorAll('[data-cyber-hero]').forEach(initMatrix);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
